import React from "react";
import "../Discussions/Discussions.css"
import Navbar from "../Navbar/Navbar";
function Discussions() {
  return (
    <>
      <Navbar />
      <hr />
      <div className="divcc">
        <div className="Discussions">
          <h2 className="h22">Discussions</h2>
        </div>
      </div>
      <div className="discuss">
        <h5>No Discussions Found.</h5>
      </div>
    </>
  );
}

export default Discussions;
